export const environment = {
  production: false,
  version: '3.2.0',
  urlReturnPse:"https://portal-dev.obsidiam.com/",
  env: 'dev',
  apiUrl: 'https://api-dev.obsidiam.com/v1/',
  apiObsicashUrl: 'https://api-dev.obsidiam.com',
  landingPageUrl: 'https://ob-dev.obsidiam.com/',
  imgUrl: 'https://cdn-dev.obsidiam.com/',
  socketUrl: 'notification/obsidiam/',
  flagUrl: 'https://ipdata.co/flags/',
  apiPse:"NDEzMWI3MDUwZDc3ZWJjNTI3ZTJmMTIyNGFlNDIwYTJiMDE0ZGRhNTUwMDNmMjhkYWJlYTE1NDY0NWM5ODNiZTI5YzJhYTk4NDA1Yjg5NTgwNDYyYmYxMTBmZGU4Mjg4NjMzMTU2OTc4ZDQzNjVjMmJjZmQxYWM3OTNjZmQxOGY=",
  configWidget:{
    merchant_id: '897',
    form_id: '915',
    terminal_id: '828'
  },
  welgotApiKey: 'wg_7584913e0aac5b5d0e168409977a105f0',
  authName: 'OBSIDIAMUSERDEV',
  cookieExpireTime: 60 * 60 * 1000, // in milliseconds (1 hour)
  allowLoader: [
    'login',
    'subscribe',
    'forgot-password',
    // 'ipapi',
    // 'check-user-exist-quick-transfer'
  ],
  firebase: {
    // apiKey: "AIzaSyAcyio7ZVuxdlilDZl_PpY9TP7sFqNhdbY",
    // authDomain: "smarty-move-map.firebaseapp.com",
    // databaseURL: "https://smarty-move-map.firebaseio.com",
    // projectId: "smarty-move-map",
    // storageBucket: "smarty-move-map.appspot.com",
    // messagingSenderId: "1090647355920",
    // appId: "1:1090647355920:web:624a28f9235086d64c5095"
    apiKey: 'AIzaSyDW582zFZyZbzKbniC7CsEdsXrshTTFRxA',
    authDomain: 'obsidiam-3cc14.firebaseapp.com',
    databaseURL: 'https://obsidiam-3cc14.firebaseio.com',
    projectId: 'obsidiam-3cc14',
    storageBucket: '',
    messagingSenderId: '235670639002',
    appId: '1:235670639002:web:4ba2b6cce534c5c9b62a23',
  },
  google_captcha: '6Lf6GtsUAAAAAIPch5vTm61smjxb4KAHkYns1haM',
  simple_exchange:
    './pages/simple-exchange/simple-exchange.module#SimpleExchangeModule',
  quick_exchange:
    './pages/quick-exchange/quick-exchange.module#QuickExchangeModule',
  simple_exchange_public:
    './pages/simple-exchange-public/simple-exchange-public.module#SimpleExchangePublicModule',
  quick_exchange_public:
    './pages/quick-exchange-public/quick-exchange-public.module#QuickExchangePublicModule',
  advance_exchange: './pages/exchange/exchange.module#ExchangeModule',
  payment: './pages/payment/payment.module#PaymentModule',
  obsicash: {
    timeReservedPrice: 30,
    timeOtp: 200,
    timerBlockGenerateOtp: 15,
    timeAuthyWithdrawal: 120,
    buyAndSellRetriesTransaction: 3,
    buyAndSellDelayRetriesTransaction: 2000,
    sessionTimeout: 15,
  },
  keyJwe: '0Ctlf3n1n4icr3_43Srct3P_s4wsr01d',
  jweUrls: {
    // Methods Get
    // Obsicash
    URL_GET_OBSICASH_USER_BALANCE: {
      url: '/obsidiam-api/obsicash-service/v1/balanceUserCop',
    },
    URL_GET_PROFILE_VERIFICATION: {
      url: '/obsidiam-api/obsicash-service/v1/users/user-documents',
    },
    URL_GET_OBSICASH_ASSOCIATE_ACCOUNT: {
      url: '/obsidiam-api/obsicash-service/v1/bank-account/',
    },
    URL_GET_OBSICASH_CASHINCONFIG: {
      url: '/obsidiam-api/obsicash-service/v1/account/cashIn/cashInConfig',
    },
    URL_GET_OBSICASH_ONBOARDING_ADDITIONAL_DATA: {
      url: '/obsidiam-api/obsicash-service/v1/onboardingAdditionalData/',
    },
    URL_GET_OBSICASH_ONBOARDING_GENERATE_OTP: {
      url: '/obsidiam-api/obsicash-service/v1/generateOtp',
    },
    URL_POST_OBSICASH_JUMIO_REGISTER: {
      url: '/obsidiam-api/obsicash-service/v1/jumio/getNetVerifyURL',
    },
    URL_GET_OBSICASH_CASHOUTCONFIG: {
      url: '/obsidiam-api/obsicash-service/v1/account/cashOut/cashOutConfig',
    },
    URL_GET_OBSICASH_PURPOSE_WITHDRAWAL: {
      url: '/obsidiam-api/obsicash-service/v1/accountPurposes/',
    },
    URL_GET_OBSICASH_COUNTRIES: {
      url: '/obsidiam-api/obsicash-service/v1/country',
    },
    URL_GET_OBSICASH_WALLET: {
      url: '/obsidiam-api/obsicash-service/v1/wallet',
    },
    URL_GET_OBSICASH_WALLET_ALIAS: {
      url: '/obsidiam-api/obsicash-service/v1/wallet',
    },
    URL_GET_OBSICASH_HISTORY_TRANSACCION: {
      url: '/obsidiam-api/obsicash-service/v1/transactions',
    },
    URL_GET_ENABLED_OBSICASH: {
      url: '/v1/user/modules/OBSICASH',
    },
    // API GLOBAL CURRENCIES BLUEBANK
    URL_GET_OBSICASH_BLUEBANK_GLOBALCURRENCIES: {
      url: '/obsidiam-api/obsicash-service/v1/currenciesByProject',
    },
    // Terms and conditions
    URL_GET_STATIC_CONTENT: {
      url: '/v1/static-content/get-content',
      jwe: false,
    },
    URL_GET_PARAMETERS_DINAMIC: {
      url: '/obsidiam-api/obsicash-service/v1/dynamic-parameters/obtainDynamicParameter',
    },
    URL_GET_ONBOARDING_BLUEBANK_DOCUMENTS: {
      url: '/v1/static-content/get-onboarding-documents',
    },
    // Methods Post
    // Obsicash

    URL_GET_OBSICASH_CASHIN: {
      url: '/obsidiam-api/obsicash-service/v1/account/cashIn/cashInInformation',
    },
    URL_POST_OBSICASH_ACCOUNT_BANK: {
      url: '/obsidiam-api/obsicash-service/v1/bank-account/list',
    },
    URL_POST_OBSICASH_IDENTIFICATION_REGISTER: {
      url: '/obsidiam-api/obsicash-service/v1/users/verifications',
    },
    URL_POST_OBSICASH_CASHOUT: {
      url: '/obsidiam-api/obsicash-service/v1/account/cashOut',
    },
    URL_POST_OBSICASH_CASHIN: {
      url: '/obsidiam-api/obsicash-service/v1/account/cashIn/internal',
    },
    URL_POST_OBSICASH_CASHOUT_FEE: {
      url: '/obsidiam-api/obsicash-service/v1/account/cashOut/cashFee',
    },
    URL_POST_OBSICASH_BLUEBANK_GLOBAL: {
      url: '/obsidiam-api/obsicash-service/v1/global',
    },

    URL_POST_OBSICASH_VERIFICATIONS_GLOBAL: {
      url: '/obsidiam-api/obsicash-service/v1/users/verificationsGlobal',
    },
    URL_GET_STATIC_CONTENT_BLUE_BANK: {
      url: '/v1/static-content/get-content-proj-bank',
      jwe: false,
    },
    URL_POST_OBSICASH_SEND_STATES: {
      url: '/obsidiam-api/obsicash-service/v1/states',
    },
    URL_POST_OBSICASH_ONBOARDING_UPLOADFILE: {
      url: '/obsidiam-api/obsicash-service/v1/uploadFile',
    },
    URL_POST_OBSICASH_ONBOARDING_DELETEFILE: {
      url: '/obsidiam-api/obsicash-service/v1/deleteFile',
    },
    // Methods Put
    // Obsicash

    URL_POST_OBSICASH_CREATE_ASSOCIATE_ACCOUNT: {
      url: '/obsidiam-api/obsicash-service/v1/bank-account/',
    },
    URL_POST_OBSICASH_SEND_COUNTRY_PENDING: {
      url: '/obsidiam-api/obsicash-service/v1/users/savePendingCountry',
    },

    URL_POST_OBSICASH_ONBOARDING_UPTADE: {
      url: '/obsidiam-api/obsicash-service/v1/onboardingStage',
    },

    URL_POST_OBSICASH_ONBOARDING_SET_STAGE: {
      url: '/obsidiam-api/obsicash-service/v1/onboardingSetStage',
    },

    URL_DELETE_OBSICASH_ONBOARDING_DELETE_ALL_USER_RECORDS: {
      url: '/obsidiam-api/obsicash-service/v1/onboardingDeleteAllUserRecords',
    },
    // Methods delete
    // Obsicash

    URL_DELETE_OBSICASH_ASSOCIATE_ACCOUNT: {
      url: '/obsidiam-api/obsicash-service/v1/bank-account/',
    },
    URL_POST_OBSICASH_APPROVE_REASON: {
      url: '/obsidiam-api/obsicash-service/v1/transactions/updatePurposeTransaction',
    },
    URL_GET_OBSICASH_LIST_WALLET: {
      url: '/obsidiam-api/obsicash-service/v1/walletListObsicash',
    },
    URL_POST_OBSICASH_GET_COIN_LIST: {
      url: '/v1/wallet/get-coin-list-user',
    },
    URL_GET_OBSICASH_ALLCOMMISSIONSCONFIG: {
      url: '/obsidiam-api/obsicash-service/v1/allCommissionsConfig'
    },
    URL_GET_LIST_DEPARTAMENTOS_QUANTUM: {
      url: '/v1/quantum/getDepartments',
    },

    URL_GET_LIST_DEPART_LOCAL_QUANTUM: {
      url: '/v1/quantum/getLocationDepartmenstByBrand',
    },
    URL_GET_REDEEM_PROMOTION_QUAMTUM: {
      url: '/v1/quantum/redeemPromotion',
    },

    URL_GET_LIST_CIUDADES_QUANTUM: {
      url: '/v1/quantum/getLocationCitiesByDepartment',
    },

    URL_GET_LIST_SITIOS_QUANTUM: {
      url: '/v1/quantum/getLocationSitesByCity',
    },

    URL_GET_LIST_CATEGORIAS_QUANTUM: {
      url: '/v1/quantum/getCategoriesAndSubCategories',
    },

    URL_GET_LIST_INFO_CATEGORIAS_QUANTUM: {
      url: '/v1/quantum/getInfoFromCategoryAndDepartment',
    },
    URL_POTS_LIST_ALL_BRANDS_QUANTUM: {
      url: '/v1/quantum/getProducts',
    },

    URL_POTS_LIST_ALL_HIGHLIGHT_QUANTUM: {
      url: '/v1/quantum/getHighlightedProducts',
    },

    URL_POTS_LIST_ALL_PRE_REDEEM: {
      url: '/v1/quantum/preRedeem',
    },
    URL_POTS_REDEEM: {
      url: '/v1/exchange/purchase',
    },
    URL_POST_OBSICASH_ONBOARDING_UPLOADFILETRUST: {
      url: '/obsidiam-api/obsicash-service/v1/trust/uploadFileTrust'
    },
    URL_GET_DIRECTORY_P2P: {
      url: '/obsidiam-api/obsicash-service/v1/trust/temporalOrder',
    },
    URL_POST_DIRECTORY_DELETEFILE: {
      url: '/obsidiam-api/obsicash-service/v1/trust/deleteFileTrust',
    },
    URL_GET_PARAMETERP2P: {
      url: '/v1/user/parameters'
    },
    URL_POST_OBSICASH_ONBOARDING_DIDI_UPDATE: {
      url: "/obsidiam-api/obsicash-service/v1/didi/didiOnboardingStage",
    },
    URL_GET_OBSICASH_ONBOARDING_DIDI_KYC_STATUS: {
      url: "/obsidiam-api/obsicash-service/v1/didi/didiKycStatus",
    },
    URL_POST_OBSICASH_ONBOARDING_DIDI_MOVEMENTS: {
      url: "/obsidiam-api/obsicash-service/v1/didi/didiMovements",
    },
    URL_POST_DIDI_ACCOUNT_INFO: {
      url: '/obsidiam-api/obsicash-service/v1/didi/didiAccountInfo'
    },
    URL_POST_OBSICASH_ONBOARDING_GENERATE_DIDI_OTP: {
      url: "/obsidiam-api/obsicash-service/v1/didi/didiGenerateOtp",
    },
    URL_POST_OBSICASH_DIDI_CHECKED_OTP: {
      url: '/obsidiam-api/obsicash-service/v1/didi/didiCheckOtp'
    },
    URL_POST_OBSICASH_DIDI_IBAN_INFO: {
      url: '/obsidiam-api/obsicash-service/v1/didi/didiIbanInfo'
    },
    URL_POST_OBSICASH_DIDI_CASHOUT: {
      url: '/obsidiam-api/obsicash-service/v1/didi/didiCashout'
    },
    URL_GET_ACH_GET_TRANSACTION_TYPES :{
      url:"/obsidiam-api/obsicash-service/v1/values/getTransactionTypes"
    },
    URL_GET_ACH_GET_BANKS :{
      url:"/obsidiam-api/obsicash-service/v1/values/getBanks"
    },
    URL_POST_CREATE_ACH_ASSOCIATE_ACCOUNT : {
      url:"/obsidiam-api/obsicash-service/v1/createAchAsociateAccounts"
    },
    URL_GET_ACH_ASSOCIATED_ACCOUNT :{
      url:"/obsidiam-api/obsicash-service/v1/achAsociateAccounts"
    },
    URL_GET_DOCUMENT_TYPE : {
      url: "/obsidiam-api/obsicash-service/v1/values/documentTypesColte"
    }

  }
};
